/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PlantLink_plant$ref = any;
type SuggestionItem_suggestionID$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SuggestionsList_occurrence$ref: FragmentReference;
declare export opaque type SuggestionsList_occurrence$fragmentType: SuggestionsList_occurrence$ref;
export type SuggestionsList_occurrence = {|
  +id: string,
  +myPerms: ?$ReadOnlyArray<?string>,
  +identity: ?{|
    +id: string,
    +$fragmentRefs: PlantLink_plant$ref,
  |},
  +suggestions: ?{|
    +totalCount: ?number,
    +edgeCount: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: SuggestionItem_suggestionID$ref,
      |}
    |}>,
  |},
  +$refType: SuggestionsList_occurrence$ref,
|};
export type SuggestionsList_occurrence$data = SuggestionsList_occurrence;
export type SuggestionsList_occurrence$key = {
  +$data?: SuggestionsList_occurrence$data,
  +$fragmentRefs: SuggestionsList_occurrence$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SuggestionsList_occurrence",
  "type": "Occurrence",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "suggestions"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "myPerms",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "identity",
      "storageKey": null,
      "args": null,
      "concreteType": "LifeNode",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "FragmentSpread",
          "name": "PlantLink_plant",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "suggestions",
      "name": "__Occurrence_suggestions_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "SuggestionIDConnection",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalCount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "edgeCount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "SuggestionIDEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "SuggestionID",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "SuggestionItem_suggestionID",
                  "args": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '69dc1d22a881f80b5d2adf5010d75e7c';
module.exports = node;
